import React, { useEffect, useState } from "react";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import {
  Alert,
  DialogContent,
  DialogContentText,
  TextField,
} from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";

import Notification from "../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import { paymentDeletedAction } from "../../../store/reducers/paymentSlice";

interface DeleteModelPopupProps {
  title?: string;
  open?: boolean;
  selectedPaymentId?: any;
  onHide?: () => void;
  clientDetails?: any;
  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  resetAllValidator?: any;
  setIsClickReset?: any;
}
const DeleteModel: React.FC<DeleteModelPopupProps> = ({
  onHide,
  alertModalShow,
  setAlertModelShow,
  setIsClickReset,
  selectedPaymentId= "",
  title,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [formData, setFormData] = useState({
    delete_reason: "",
  });
  const [reasonError, setReasonError] = useState(false);

  const submitHandler = () => {
    if (!formData.delete_reason.trim()) {
      setReasonError(true);
    //   dispatch(
    //     setNotificationAction({
    //       message: ["Please provide a reason before deleting."],
    //       severity: "error",
    //     })
    //   );
      return;
    }

    dispatch(paymentDeletedAction({ selectedPaymentId, ...formData }));
    setAlertModelShow(false); // close modal on success
    setFormData({ delete_reason: "" }); // reset form data
    setReasonError(false); // reset error state
  };

  const closeModel = () => {
    setAlertModelShow(false);
    setFormData({ delete_reason: "" }); // reset form data
    setReasonError(false); // reset error state
    dispatch(setNotificationAction({ message: [], severity: "info" }));
  };

  return (
    <Popup
      open={alertModalShow}
      title={"Undo Payment"}
      onHide={closeModel}
      fullWidth={true}
      maxWidth={"sm"}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton title="Yes" onClick={submitHandler} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <Notification />
          <Alert
            sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
            severity="warning"
          >
            Are you sure you want to undo this payment? If yes, please provide a reason to undo this payment.
          </Alert>
          <TextField
            fullWidth
            multiline
            minRows={3}
            maxRows={6}
            label="Reason"
            variant="outlined"
            value={formData.delete_reason}
            onChange={(e) => {
              const value = e.target.value;
              setFormData((prev) => ({
                ...prev,
                delete_reason: value,
              }));
              if (value.trim()) {
                setReasonError(false); // clear error when valid
              }
            }}
            error={reasonError}
            helperText={reasonError ? "Reason is required." : ""}
            sx={{ marginTop: 2, bgcolor: "#fff" }}
          />
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default DeleteModel;
